import { OperationTypeNode } from 'graphql/language'
import { Kind } from 'graphql/language/kinds'
import { createTrackOperationStatusLink } from 'lib/apollo-client/links/helpers/createTrackOperationStatusLink/createTrackOperationStatusLink'
import { useOperationStatusStore } from 'lib/hooks/useOperationStatusStore/useOperationStatusStore'

const store = useOperationStatusStore.getState()

export const trackMutationStatusLink = createTrackOperationStatusLink(
  {
    onStartOperation: store.startLoading,
    onEndOperation: store.stopLoading,
    onOperationError: store.setError,
  },
  (operation) => {
    const operationDefinition = operation.query.definitions.find(
      (definition) => definition.kind === Kind.OPERATION_DEFINITION,
    )

    if (!operationDefinition) {
      return false
    }
    return operationDefinition.operation === OperationTypeNode.MUTATION
  },
)
